export const GHIN_STAGING_URL = 'https://api-uat.ghin.com/api/v1';
